import { render, staticRenderFns } from "./HeaderTeam.vue?vue&type=template&id=0412570e&scoped=true&"
import script from "./HeaderTeam.vue?vue&type=script&lang=js&"
export * from "./HeaderTeam.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTeam.vue?vue&type=style&index=0&id=0412570e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0412570e",
  null
  
)

export default component.exports